<template>
    <Card>
        <div class="multiple">
            <div class="child-div">时间区间</div>
            <RadioGroup v-model="timePeriod" @on-change="timePeriodClick">
                <Radio label="0"><span>月</span></Radio>
                <Radio label="1"><span>周</span></Radio>
                <Radio label="2"><span>天</span></Radio>
                <Radio label="3"><span>自定义</span></Radio>
                <DatePicker v-if="timePeriod =='3' " :value="timePeriodDate" @on-change="timePeriodDateChange"
                            type="daterange"
                            placeholder="选择日期" style="width: 200px"></DatePicker>
            </RadioGroup>
			<div style="padding-left: 50px">
				<Button class="ivu-btn-circle" @click="getList" type="primary">搜索</Button>
			</div>
        </div>
        <div class="multiple">
            <div class="child-div">分公司</div>
            <Select v-model="shopId" style="width:200px">
                <Option v-for="item in shopIdList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
            <div class="child-div" style="margin-left: 20px;">媒体代码</div>
            <Select v-model="mediumCodeId" style="width:200px">
                <Option v-for="item in mediumCodeIdList" :value="item.value" :key="item.value">{{ item.label }}</Option>
            </Select>
        </div>
        <div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px;">客户数量</div>
        <div id="MimelistOne"></div>
        <div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px;">优质率</div>
        <div id="MimelistTwo"></div>
		<div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px;">员工趋势</div>
		<div id="MimelistFive"></div>
		<div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px;">直客占比</div>
		<div id="MimelistFour"></div>
        <div style="background-color: #454545; ">
            <div style="text-align: center; font-size: 20px;font-weight: bold; margin-top: 20px; color: #FFFFFF;">ROI
            </div>
            <div id="Mimelist2"></div>
            <div style="width: 100%; color: #FFFFFF; padding: 0px 10px 10px; overflow: auto;" class="tabel_scroll">
                <table border="1" cellspacing="0" style="width: 100%;">
                    <tr>
                        <th></th>
                        <th v-for="(item,index) in table_th_list" :key="index">{{item}}</th>
                    </tr>
                    <tr>
                        <td>
                            <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                                <div style="height: 10px; width: 30px; background-color: #9D7200;"></div>
                                <span>成本</span>
                            </div>
                        </td>
                        <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionRoi.series[0].data"
                            :key="index">{{item}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style="display: flex; align-items: center; justify-content: center;width: 120px;">
                                <div style="height: 10px; width: 30px; background-color:#215E95;"></div>
                                <span>创收</span>
                            </div>
                        </td>
                        <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionRoi.series[1].data"
                            :key="index">{{item}}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style="display: flex; align-items: center; justify-content: center;width: 135px;">
                                <div style="height: 5px; width: 30px; background-color: #58A4E3;"></div>
                                <span>签约率</span>
                            </div>
                        </td>
                        <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionRoi.series[2].data"
                            :key="index">{{item}}%
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div style="display: flex; align-items: center; justify-content: center;width: 135px;">
                                <div style="height: 5px; width: 30px; background-color: #A44602;"></div>
                                <span>上门率</span>
                            </div>
                        </td>
                        <td style="text-align: center; font-weight: bold;" v-for="(item,index) in optionRoi.series[3].data"
                            :key="index">{{item}}%
                        </td>
                    </tr>
                </table>
            </div>
        </div>
    </Card>
</template>

<script>
    import {getAllMediumCode, getAllShop, getTrendAnalysis} from "../../api/runSet";
	import {mapGetters} from "vuex";

    export default {
        name: "TrendAnalysis",
        data() {
            return {
                shopId: '',
                shopIdList: [{value: 0, label: '全部'}],
                customList: [],
                weekList: [],
                mediumCodeId: '',
                mediumCodeIdList: [{value: 0, label: '全部'}],
                cityValue: [],
                timePeriodDate: [],
                table_th_list: [],
                weekDayList: [],
                yearMonthList: [],
                timePeriod: '0',
                timePeriodList: [{
                    value: '0',
                    label: '最近7天'
                },
                    {
                        value: '1',
                        label: '最近15天'
                    },
                    {
                        value: '2',
                        label: '最近30天'
                    },
                    {
                        value: '3',
                        label: '最近1年'
                    },
                    {
                        value: '4',
                        label: '最近2年'
                    },
                ],
                optionTwo: {

                    dataZoom: [{
                        type: 'slider',
                        show: false, //flase直接隐藏图形
                        xAxisIndex: [0],
                        left: '9%', //滚动条靠左侧的百分比
                        bottom: -5,
                        start: 0, //滚动条的起始位置
                        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    }],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        formatter: function (params) {
                            var htmlStr = '';
                            htmlStr += '<div><span style="color:#fff;">' + params[0].name + '</span><br/> ';
                            for (var i = 0; i < params.length; i++) {
                                //前面的原点和他的颜色

                                htmlStr += '<span style="width: 8px;height: 8px;display:inline-block;border-radius: 50%;background-color:' +
                                    params[i].color + '"></span><span style="color:#fff;">' + params[i].seriesName + ':</span>' +
                                    '<span style="color:#fff;">' + params[i].value + '%</span><br/>';

                            }
                            htmlStr += '</div>';
                            return htmlStr
                        },
                    },
                    legend: {
                        data: ['有效率', '优质率', '0星占比'],
                        top: '',
                    },
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            formatter: '{value} %',
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    },
                        {
                            type: 'value',
                            min: 0,
                            show: false,
                            splitLine: {
                                show: false
                            },
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [
                        {
                            name: '有效率',
                            type: 'line',
                            color: '#4372C5',
                            data: [30, 32, 31, 34, 39, 33, 32, 34, 39, 33, 32, 34],
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        width: 5 //设置线条粗细
                                    },
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 16,
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    }
                                }
                            },
                        },
                        {
                            name: '优质率',
                            type: 'line',
                            color: '#ffaa00',
                            data: [10, 12, 11, 14, 19, 13, 12, 14, 19, 13, 12, 14],
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        width: 5 //设置线条粗细
                                    },
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 16,
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    }
                                }
                            },
                        },
                        {
                            name: '0星占比',
                            type: 'line',
                            color: '#434343',
                            data: [20, 22, 21, 24, 29, 23, 22, 24, 29, 23, 22, 24],
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        width: 5 //设置线条粗细
                                    },
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'black',
                                            fontSize: 16,
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    }
                                }
                            },
                        }
                    ],
                },
                optionOne: {
                    dataZoom: [{
                        type: 'slider',
                        show: false, //flase直接隐藏图形
                        xAxisIndex: [0],
                        left: '9%', //滚动条靠左侧的百分比
                        bottom: -5,
                        start: 0, //滚动条的起始位置
                        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    }],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                    },
                    legend: {
                        data: ['客户数', '有效数', '上门数', '签约数', '放款数'],
                        top: '',
                    },
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    },
                        {
                            type: 'value',
                            min: 0,
                            show: false,
                            splitLine: {
                                show: false
                            },
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [
                        {
                            name: '客户数',
                            type: 'bar',
                            stack: '总量',
                            color: '#4372C5',
                            label: {
                                show: true,
                                position: 'inside',

                            },
                            data: [30,32,31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
                        },
                        {
                            name: '有效数',
                            type: 'bar',
                            stack: '总量',
                            color: '#ED7D31',
                            label: {
                                show: true,
                                position: 'inside',

                            },
                            data: [30, 32, 31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
                        },
                        {
                            name: '上门数',
                            type: 'bar',
							barGap:60,
                            stack: '总量',
                            color: '#F9BF0C',
                            label: {
                                show: true,
                                position: 'inside',
                            },
                            data: [10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10, 10]
                        },
                        {
                            name: '签约数',
                            type: 'bar',
							barGap:40,
                            stack: '总量',
                            color: '#5A9BD5',
                            label: {
                                show: true,
                                position: 'inside',

                            },
                            data: [10, 10, 10, 10, 10, 5, 16, 10, 10, 10, 10, 10]
                        },
                        {
                            name: '放款数',
                            type: 'bar',
							barGap:20,
							barCategoryGap: '40%',
                            stack: '总量',
                            color: '#70AD46',
                            label: {
                                show: true,
                                position: 'inside',
                                textStyle: {}
                            },
                            data: [10, 10, 10, 10, 10, 10, 5, 10, 10, 10, 10, 10]
                        },
                    ],

                },
				optionFour: {
				    dataZoom: [{
				        type: 'slider',
				        show: false, //flase直接隐藏图形
				        xAxisIndex: [0],
				        left: '9%', //滚动条靠左侧的百分比
				        bottom: -5,
				        start: 0, //滚动条的起始位置
				        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
				    }],
				    tooltip: {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            crossStyle: {
				                color: '#999'
				            }
				        },
				    },
				    legend: {
				        data: ['直客', '拓客'],
				        top: '',
				    },
				    xAxis: [{
				        type: 'category',
				        data: [],
				        axisPointer: {
				            type: 'shadow'
				        },
				        axisTick: { //x轴刻度线
				            show: false
				        },
				        axisLine: { //x轴
				            show: false
				        },
				    }],
				    yAxis: [{
				        type: 'value',
				        min: 0,
				        splitLine: {
				            show: false
				        },
				        axisTick: { //y轴刻度线
				            show: false
				        },
				        axisLine: { //y轴
				            show: false
				        },
				    },
				        {
				            type: 'value',
				            min: 0,
				            show: false,
				            splitLine: {
				                show: false
				            },
				            axisTick: { //y轴刻度线
				                show: false
				            },
				            axisLine: { //y轴
				                show: false
				            },
				        }
				    ],
				    series: [
				        {
				            name: '直客',
				            type: 'bar',
				            stack: '总量',
				            color: '#4372C5',
				            label: {
				                show: true,
				                position: 'inside',
				
				            },
				            data: [30,32,31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
				        },
				        {
				            name: '拓客',
				            type: 'bar',
				            stack: '总量',
				            color: '#ED7D31',
				            label: {
				                show: true,
				                position: 'inside',
				
				            },
				            data: [30, 32, 31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
				        },
				    ],
				
				},
				optionFive: {
				    dataZoom: [{
				        type: 'slider',
				        show: false, //flase直接隐藏图形
				        xAxisIndex: [0],
				        left: '9%', //滚动条靠左侧的百分比
				        bottom: -5,
				        start: 0, //滚动条的起始位置
				        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
				    }],
				    tooltip: {
				        trigger: 'axis',
				        axisPointer: {
				            type: 'cross',
				            crossStyle: {
				                color: '#999'
				            }
				        },
				    },
				    legend: {
				        data: ['当月在职', '当月入职','当月离职'],
				        top: '',
				    },
				    xAxis: [{
				        type: 'category',
				        data: [],
				        axisPointer: {
				            type: 'shadow'
				        },
				        axisTick: { //x轴刻度线
				            show: false
				        },
				        axisLine: { //x轴
				            show: false
				        },
				    }],
				    yAxis: [{
				        type: 'value',
				        min: 0,
				        splitLine: {
				            show: false
				        },
				        axisTick: { //y轴刻度线
				            show: false
				        },
				        axisLine: { //y轴
				            show: false
				        },
				    },
				        {
				            type: 'value',
				            min: 0,
				            show: false,
				            splitLine: {
				                show: false
				            },
				            axisTick: { //y轴刻度线
				                show: false
				            },
				            axisLine: { //y轴
				                show: false
				            },
				        }
				    ],
				    series: [
				        {
				            name: '当月在职',
				            type: 'bar',

				            color: '#4372C5',
				            label: {
				                show: true,
				                position: 'inside',
				
				            },
				            data: [30,32,31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
				        },
				        {
				            name: '当月入职',
				            type: 'bar',

				            color: 'green',
				            label: {
				                show: true,
				                position: 'inside',
				
				            },
				            data: [30, 32, 31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
				        },
						{
						    name: '当月离职',
						    type: 'bar',
						
						    color: 'red',
						    label: {
						        show: true,
						        position: 'inside',
										
						    },
						    data: [30, 32, 31, 34, 39, 33, 32, 34, 39, 33, 32, 34]
						},
				    ],
				
				},
                optionRoi: {
                    backgroundColor: '#454545',
                    dataZoom: [{
                        type: 'slider',
                        show: false, //flase直接隐藏图形
                        xAxisIndex: [0],
                        left: '9%', //滚动条靠左侧的百分比
                        bottom: -5,
                        start: 0, //滚动条的起始位置
                        end: 100 //滚动条的截止位置（按比例分割你的柱状图x轴长度）
                    }],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'cross',
                            crossStyle: {
                                color: '#999'
                            }
                        },
                        formatter: function (params) {
                            var htmlStr = '';
                            htmlStr += '<div><span style="color:#fff;">' + params[0].name + '</span><br/> ';
                            for (var i = 0; i < params.length; i++) {
                                //前面的原点和他的颜色
                                if (params[i].seriesName == "签约率" || params[i].seriesName == "上门率") {
                                    htmlStr += '<span style="width: 8px;height: 8px;display:inline-block;border-radius: 50%;background-color:' +
                                        params[i].color + '"></span><span style="color:#fff;">' + params[i].seriesName + ':</span>' +
                                        '<span style="color:#fff;">' + params[i].value + '&nbsp;%</span><br/>';
                                } else {
                                    htmlStr += '<span style="width: 8px;height: 8px;display:inline-block;border-radius: 50%;background-color:' +
                                        params[i].color + '"></span><span style="color:#fff;">' + params[i].seriesName + ':</span>' +
                                        '<span style="color:#fff;">' + params[i].value + '</span><br/>';
                                }
                            }
                            htmlStr += '</div>';
                            return htmlStr
                        },
                    },
                    legend: {
                        data: ['成本', '创收', '签约率', '上门率'],
                        top: '',
                        textStyle: {
                            color: '#ffffff' //字体颜色
                        },
                    },
                    xAxis: [{
                        type: 'category',
                        data: [],
                        axisPointer: {
                            type: 'shadow'
                        },
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        axisTick: { //x轴刻度线
                            show: false
                        },
                        axisLine: { //x轴
                            show: false
                        },
                    }],
                    yAxis: [{
                        type: 'value',
                        min: 0,
                        axisLabel: {
                            show: true,
                            interval: 'auto',
                            textStyle: {
                                color: '#fff'
                            }
                        },
                        splitLine: {
                            show: false
                        },
                        axisTick: { //y轴刻度线
                            show: false
                        },
                        axisLine: { //y轴
                            show: false
                        },
                    },
                        {
                            type: 'value',
                            min: 0,
                            splitLine: {
                                show: false
                            },
                            axisLabel: {
                                show: true,
                                interval: 'auto',
                                formatter: '{value} %',
                                textStyle: {
                                    color: '#fff'
                                }
                            },
                            axisTick: { //y轴刻度线
                                show: false
                            },
                            axisLine: { //y轴
                                show: false
                            },
                        }
                    ],
                    series: [{
                        name: '成本',
                        type: 'bar',
                        data: [10, 20, 30, 40, 50, 60, 70, 10, 20, 30, 40, 50],
                        color: '#9D7200',
                    },
                        {
                            name: '创收',
                            type: 'bar',
                            data: [10, 20, 30, 40, 50, 60, 70, 40, 50, 60, 70, 10],
                            color: '#215E95'
                        },
                        {
                            name: '签约率',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [20, 10, 20, 30, 20, 10, 30, 20, 10, 10, 10, 20],
                            color: '#58A4E3',
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        width: 5 //设置线条粗细
                                    },
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'white',
                                            fontSize: 16,
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    }
                                }
                            },
                        },
                        {
                            name: '上门率',
                            type: 'line',
                            yAxisIndex: 1,
                            data: [30, 40, 60, 50, 50, 60, 70, 40, 50, 60, 70, 60],
                            color: '#A54602',
                            itemStyle: {
                                normal: {
                                    lineStyle: {
                                        width: 5 //设置线条粗细
                                    },
                                    label: {
                                        show: true, //开启显示
                                        position: 'top', //在上方显示
                                        textStyle: { //数值样式
                                            color: 'white',
                                            fontSize: 16
                                        },
                                        formatter: function (params) {
                                            if (params.value) {
                                                return params.value + '%'
                                            } else {
                                                return '';
                                            }
                                        }
                                    }
                                }
                            },
                        }
                    ],
                },


            }
        },
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
        mounted() {
            this.timestampToMonth(12)
            this.optionRoi.xAxis[0].data = this.yearMonthList
            this.optionOne.xAxis[0].data = this.yearMonthList
            this.optionTwo.xAxis[0].data = this.yearMonthList
			this.optionFour.xAxis[0].data = this.yearMonthList
			this.optionFive.xAxis[0].data = this.yearMonthList
            this.optionRoi.dataZoom[0].show = false
            this.optionRoi.dataZoom[0].end = 100
            this.optionOne.dataZoom[0].show = false
            this.optionOne.dataZoom[0].end = 100
            this.optionTwo.dataZoom[0].show = false
            this.optionTwo.dataZoom[0].end = 100
            this.optionFour.dataZoom[0].show = false
            this.optionFour.dataZoom[0].end = 100
			this.optionFive.dataZoom[0].show = false
			this.optionFive.dataZoom[0].end = 100	
            this.table_th_list = this.yearMonthList
            this.loadData();
            this.getList();
        },
        methods: {
			async loadData() {
				let that = this;
				let data = {}
				data.token = this.token;
				let res = await getAllMediumCode(that, data);
                res.data.list.forEach(function (row, index) {
                    that.mediumCodeIdList.push({label: row.name, value: row.id});
                })
                res = await getAllShop(that, data);
                res.data.list.forEach(function (row, index) {
                    that.shopIdList.push({label: row.name, value: row.id});
                })
			},
        	async getList() {
				let that = this;
				let data = {timePeriod: this.timePeriod, city: this.cityValue, mediumCodeId: that.mediumCodeId, monthList: this.yearMonthList, weekList: this.weekList, dayList: this.weekDayList, chooseList: that.customList}
				data.token = this.token;
				data.shopId = this.shopId;
				let res = await getTrendAnalysis(that, data);
				that.optionOne.series[0].data = res.data.clientNums[0];
				that.optionOne.series[1].data = res.data.clientNums[1];
				that.optionOne.series[2].data = res.data.clientNums[2];
				that.optionOne.series[3].data = res.data.clientNums[3];
				that.optionOne.series[4].data = res.data.clientNums[4];
				console.log(that.optionOne.series[4].data);
				//that.optionOne.series[5].data = res.data.clientNums[5];
				let myChartOne = this.$echarts.init(document.getElementById("MimelistOne"));
				myChartOne.clear()
				myChartOne.setOption(this.optionOne);
				that.optionTwo.series[0].data = res.data.qualityNums[0];
				that.optionTwo.series[1].data = res.data.qualityNums[1];
				that.optionTwo.series[2].data = res.data.qualityNums[2];
				let myChartTwo = this.$echarts.init(document.getElementById("MimelistTwo"));
				myChartTwo.clear()
				myChartTwo.setOption(this.optionTwo);
				that.optionRoi.series[0].data = res.data.roiNums[0];
				that.optionRoi.series[1].data = res.data.roiNums[1];
				that.optionRoi.series[2].data = res.data.roiNums[2];
				that.optionRoi.series[3].data = res.data.roiNums[3];
				let myChartThree = this.$echarts.init(document.getElementById("Mimelist2"));
				myChartThree.clear()
				myChartThree.setOption(this.optionRoi);
				that.optionFour.series[0].data = res.data.repayNums[0];
				that.optionFour.series[1].data = res.data.repayNums[1];				
				let myChartFour = this.$echarts.init(document.getElementById("MimelistFour"));
				myChartFour.clear()
				myChartFour.setOption(this.optionFour);
				
				that.optionFive.series[0].data = res.data.userNums[0];
				that.optionFive.series[1].data = res.data.userNums[1];
				that.optionFive.series[2].data = res.data.userNums[2];	
				let myChartFive = this.$echarts.init(document.getElementById("MimelistFive"));
				myChartFive.clear()
				myChartFive.setOption(this.optionFive);
			},
            timePeriodClick(e) {
                if (e == '0') {
                    this.timestampToMonth(12)
                    this.optionRoi.xAxis[0].data = this.yearMonthList
                    this.optionOne.xAxis[0].data = this.yearMonthList
                    this.optionTwo.xAxis[0].data = this.yearMonthList
                    this.optionRoi.dataZoom[0].show = false
                    this.optionRoi.dataZoom[0].end = 100
                    this.optionOne.dataZoom[0].show = false
                    this.optionOne.dataZoom[0].end = 100
                    this.optionTwo.dataZoom[0].show = false
                    this.optionTwo.dataZoom[0].end = 100
                    this.table_th_list = this.yearMonthList
                } else if (e == '1') {
                    this.timestampToWeek(4)
                    this.optionOne.xAxis[0].data = this.weekList
                    this.optionRoi.xAxis[0].data = this.weekList
                    this.optionTwo.xAxis[0].data = this.weekList
                    this.optionRoi.dataZoom[0].show = false
                    this.optionRoi.dataZoom[0].end = 100
                    this.optionOne.dataZoom[0].show = false
                    this.optionOne.dataZoom[0].end = 100
                    this.optionTwo.dataZoom[0].show = false
                    this.optionTwo.dataZoom[0].end = 100
                    this.table_th_list = this.weekList
                } else if (e == '2') {
                    this.timestampToTime(7)
                    this.optionOne.xAxis[0].data = this.weekDayList
                    this.optionRoi.xAxis[0].data = this.weekDayList
                    this.optionTwo.xAxis[0].data = this.weekDayList
                    this.optionRoi.dataZoom[0].show = false
                    this.optionRoi.dataZoom[0].end = 100
                    this.optionOne.dataZoom[0].show = false
                    this.optionOne.dataZoom[0].end = 100
                    this.optionTwo.dataZoom[0].show = false
                    this.optionTwo.dataZoom[0].end = 100
                    this.table_th_list = this.weekDayList
                }
				this.getList();
            },
            timestampToTime(type) {
                // type =0 为当天 type = 1 为前一天
                // hhmmss 自己传需要的时分秒
                let now = new Date();
                let date
                if (type === 0) {
                    date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
                } else {
                    this.weekDayList = []
                    for (let i = 0; i < type; i++) {
                        let now = new Date();
                        date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
                        var time2 = date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
                        this.weekDayList.unshift(time2)
                    }
                }
            },
            timestampToWeek(type) {
                let now = new Date();
                let date
                if (type === 0) {
                    date = new Date(now + 8 * 3600 * 1000); // 增加8小时 当天
                } else {
                    this.weekList = []
                    for (let i = 0; i < type; i++) {
                        let now = new Date();
                        date = new Date(now - 3 * (i + 1) * 8 * 3600 * 1000); // type天前
                        var time2 = (date.getMonth() + 1) + "月-第" + (i + 1) + "周";
                        this.weekList.push(time2)
                    }
                }
            },
            timestampToMonth(type) {
				var currentDate = new Date();
				var year = currentDate.getFullYear();
				var month = currentDate.getMonth() + 1; // 月份从0开始，需要加1
				var months = [];
				
				for (var i = 0; i < 12; i++) {
				  if (month - i <= 0) {
				    months.push((year - 1) + '-' + (12 + month - i));
				  } else {
				    months.push(year + '-' + (month - i));
				  }
				}
				months.reverse();
				this.yearMonthList = months;
            },

            getAll(begin, end) {
                var ab = begin.split("-");
                var ae = end.split("-");
                var db = new Date();
                db.setUTCFullYear(ab[0], ab[1] - 1, ab[2]);
                var de = new Date();
                de.setUTCFullYear(ae[0], ae[1] - 1, ae[2]);
                var unixDb = db.getTime();
                var unixDe = de.getTime();
                this.customList = [];
                for (var k = unixDb; k <= unixDe;) {
                    this.customList.push((new Date(parseInt(k))).formatTime())
                    k = k + 24 * 60 * 60 * 1000;
                }
                return this.customList
            },
            timePeriodDateChange(e) {
                this.timePeriodDate = e
                this.optionOne.xAxis[0].data = this.getAll(e[0], e[1])
                this.optionTwo.xAxis[0].data = this.getAll(e[0], e[1])
                this.optionRoi.xAxis[0].data = this.getAll(e[0], e[1])
                if (this.getAll(e[0], e[1]).length > 12 && this.getAll(e[0], e[1]).length < 30) {
                    this.optionRoi.dataZoom[0].show = true
                    this.optionRoi.dataZoom[0].end = 30
                    this.optionOne.dataZoom[0].show = true
                    this.optionOne.dataZoom[0].end = 30
                    this.optionTwo.dataZoom[0].show = true
                    this.optionTwo.dataZoom[0].end = 30
                } else if (this.getAll(e[0], e[1]).length > 30) {
                    this.optionRoi.dataZoom[0].show = true
                    this.optionRoi.dataZoom[0].end = 15
                    this.optionOne.dataZoom[0].show = true
                    this.optionOne.dataZoom[0].end = 15
                    this.optionTwo.dataZoom[0].show = true
                    this.optionTwo.dataZoom[0].end = 15
                } else {
                    this.optionRoi.dataZoom[0].show = false
                    this.optionRoi.dataZoom[0].end = 100
                    this.optionOne.dataZoom[0].show = false
                    this.optionOne.dataZoom[0].end = 100
                    this.optionTwo.dataZoom[0].show = false
                    this.optionTwo.dataZoom[0].end = 100
                }
                this.table_th_list = this.getAll(e[0], e[1])
				this.getList();
            },
        }
    }
</script>

<style scoped lang="less">
    #Mimelist2 {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
    }

    #MimelistOne {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
    }

    #MimelistTwo {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
    }
    #MimelistFour {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
    }
    #MimelistFive {
        width: 100%;
        height: 300px;
        background-color: #FFFFFF;
    }
    .tabel_scroll::-webkit-scrollbar {
        width: 5px;
        height: 10px;
        background-color: #f5f5f5;
    }

    .tabel_scroll::-webkit-scrollbar-thumb {
        border-radius: 3px;
        background: #6C727B;
    }

    .tabel_scroll::-webkit-scrollbar-track {
        background: #454545;
    }

    .multiple {
        display: flex;
        justify-content: left;
        margin-top: 10px;
        align-items: center;

        .child-div {
            width: 70px;
            height: 20px;
            margin-right: 30px;
            text-align-last: justify;
        }
    }
</style>
